import React from 'react'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import { Text } from '@quotatisgroup/uikit-public.ui.text'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import cloudinary from 'utils/cloudinary'
import injectTranslate from 'i18n/hoc/injectTranslate'
import PropTypes from 'prop-types'
import uuid from 'uuid/v4'

const PricingBlock = ({
  // eslint-disable-next-line no-unused-vars
  translate,
  headlineText,
  endlineText,
  endlineLinkText,
  columns,
}) => (
  <Container>
    <Row mdMargin="bottom-xl" padding="md" mdPadding="lg" hasShadow>
      <Col sm="12" md="12">
        <Title headingLevel="2" align="center" mdPadding="bottom-md">
          {
            headlineText /* Pourquoi faire des Forfaits de pose avec Quotatis? */
          }
        </Title>
      </Col>
      {columns.map(({ title, text, image, alt }) => (
        <Col
          key={uuid()}
          sm="12"
          md="3"
          align="center"
          mdPadding="horizontal-sm"
        >
          <Image
            src={cloudinary(`/vitrine/illustration/${image}.png`)}
            size="lg"
            alt={alt}
          />
          <Title headingLevel="3">{title}</Title>
          <Text color="grey">{text}</Text>
        </Col>
      ))}
      <Col sm="12" md="12">
        <Title headingLevel="3" align="center" padding="top-md">
          {`${endlineText} ` /* Votre seul engagement : respecter notre */}
          <UniverseLink
            id="endline-link"
            href="https://lecoindespros.quotatis.fr/charte-de-qualite/"
          >
            {endlineLinkText /* charte de qualité. */}
          </UniverseLink>
        </Title>
      </Col>
    </Row>
  </Container>
)

PricingBlock.propTypes = {
  translate: PropTypes.func,
  headlineText: PropTypes.string,
  endlineText: PropTypes.string,
  endlineLinkText: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }),
  ),
}

export default injectTranslate(PricingBlock)
